import { z } from "zod/v4";
const TenantPhaseList = [
    "setup",
    "trial",
    "onboading",
    "adoption",
    "closed",
    "demo",
];
const INITIAL_PHASE = "setup";
const TenantPhaseSchema = z.enum(TenantPhaseList).brand();
const display = (phase) => {
    switch (phase) {
        case "setup":
            return "環境構築中";
        case "trial":
            return "トライアル中";
        case "onboading":
            return "本導入中";
        case "adoption":
            return "サポート移管済み";
        case "closed":
            return "失注";
        case "demo":
            return "デモ";
        default:
            return "不明";
    }
};
export const TenantPhase = {
    schema: TenantPhaseSchema,
    initial() {
        return TenantPhase.schema.parse(INITIAL_PHASE);
    },
    of: (phase) => TenantPhase.schema.parse(phase),
    display,
};
//# sourceMappingURL=tenant-phase.js.map